'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styles from './HeroImage.module.css';
export function HeroImage({ src, height = 240, }) {
    const [errored, setErrored] = useState(false);
    // Reset error state when src changes so a new url gets a fresh load attempt.
    useEffect(() => {
        setErrored(false);
    }, [src]);
    // The image is a real <img> (not a CSS background) so the browser can
    // async-decode it and future responsive-srcset work has an element to
    // target. Heroes sit above the fold, so loading stays eager (the default).
    // The darkening gradient layers on top; a broken / 404'd URL falls back
    // to the gradient alone.
    return (_jsxs("div", { className: styles.hero, style: {
            '--hero-h': `${height}px`,
            position: 'relative',
            overflow: 'hidden',
        }, children: [!errored && (_jsx("img", { src: src, alt: "", decoding: "async", draggable: false, onError: () => setErrored(true), style: {
                    position: 'absolute',
                    inset: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                } })), _jsx("div", { "aria-hidden": true, style: {
                    position: 'absolute',
                    inset: 0,
                    background: 'linear-gradient(180deg, rgba(0,0,0,0) 30%, rgba(0,0,0,.65) 100%)',
                } })] }));
}
//# sourceMappingURL=HeroImage.js.map